"use strict";

const lightfoot_photo = require("../../assets/img/candidate-photo-w-bg/lightfoot.jpg"),
  green_photo = require("../../assets/img/candidate-photo-w-bg/green.jpg"),
  buckner_photo = require("../../assets/img/candidate-photo-w-bg/buckner.jpg"),
  garcia_photo = require("../../assets/img/candidate-photo-w-bg/garcia.jpg"),
  johnson_photo = require("../../assets/img/candidate-photo-w-bg/johnson.jpg"),
  king_photo = require("../../assets/img/candidate-photo-w-bg/king.jpg"),
  sawyrer_photo = require("../../assets/img/candidate-photo-w-bg/sawyer.jpg"),
  vallas_photo = require("../../assets/img/candidate-photo-w-bg/vallas.jpg"),
  wilson_photo = require("../../assets/img/candidate-photo-w-bg/wilson.jpg");

const photos = {
  lightfoot: lightfoot_photo,
  green: green_photo,
  buckner: buckner_photo,
  garcía: garcia_photo,
  johnson: johnson_photo,
  king: king_photo,
  sawyer: sawyrer_photo,
  vallas: vallas_photo,
  wilson: wilson_photo,
};

const arrExtendedChars = ["”", "“"];

const arrReplacements = ["&rdquo;", "&ldquo;"];
const fixText = (text) => {
  let newText;
  for (var i = 0; i < arrExtendedChars.length; i++) {
    newText = text.replace(
      new RegExp(arrExtendedChars[i], "ig"),
      arrReplacements[i]
    );
  }
  return newText.trim();
};

export const candidates = d3.select("#candidates");
const alderperson = candidates.append("div").attr("class", "alderperson");
const mayor = candidates.append("div").attr("class", "mayoral");
const police_department = candidates
  .append("div")
  .attr("class", "police-department");

mayor.append("h3").text("Meet the mayoral candidates");
const mayors_list = mayor.append("div").attr("class", "mayors-list");

alderperson.append("h3").text("Meet your aldermanic candidates");
export const ald_list = alderperson.append("div").attr("class", "list");

police_department
  .append("h3")
  .text("Meet your police district council candidates");
export const pd_list = police_department.append("div").attr("class", "list");

mayor_data
  .sort((a, b) => {
    return +a.ballotorder > +b.ballotorder ? 1 : -1;
  })
  .map((mayor) => {
    const card = mayors_list.append("div").attr("class", "mayor-list");
    console.log(mayor.lastname);
    card.append("img").attr("src", photos[mayor.lastname.toLowerCase()]);
    const hed = card.append("div").attr("class", "mayor-hed");
    // hed.append("div").attr("class", `mayor-photo ${mayor.lastname}`);
    const hed_info = hed.append("div").attr("class", "mayor-info");
    hed_info
      .append("p")
      .attr("class", "name")
      .text(`${mayor.firstname} ${mayor.lastname}`);
    const dob = moment(mayor.dob);
    const electionday = moment("02/28/2023");
    const age = electionday.diff(dob, "years");
    hed_info
      .append("p")
      .attr("class", "age")
      .text(`${mayor.occupation}, ${age} years old`);

    hed_info
      .append("a")
      .attr("class", "video")
      .attr("target", "_blank")
      .attr("href", mayor.candidatevideo)
      .html(`<i class="fa-solid fa-video"></i> Watch the video`)
      .on("click", () => {
        window.dataLayer.push({
          dl_candidateName: `${mayor.firstname} ${mayor.lastname}`,
          dl_destinationURL: mayor.candidatevideo,
        });
      });
    hed_info
      .append("div")
      .attr("class", "socials")
      .selectAll("social")
      .data(
        [
          "website",
          "fb",
          "twitter",
          "ig",
          "tiktok",
          "linkedin",
          "youtube",
        ].filter((d) => mayor[d])
      )
      .enter()
      .append("a")
      .attr("target", "_blank")
      .attr("href", (d) => {
        if (d === "twitter") return `https://twitter.com/${mayor[d]}`;
        return mayor[d];
      })
      .html((d) => social_icons[d]);
  });

const toggle_arrows = (bool) =>
  bool
    ? '<i class="fa-solid fa-angle-up"></i>'
    : '<i class="fa-solid fa-angle-down"></i>';

const render_card = (container, candidate) => {
  const card = container.append("div").attr("class", "card");
  const card_hed = card.append("div").attr("class", "card-hed");
  const main_info = card_hed.append("div").attr("class", "main-info");
  const hed = main_info.append("div").attr("class", "hed");

  // candidate.firstname = candidate.firstname
  //   .replace("“", "<span>&ldquo;</span>")
  //   .replace("”", "<span>&rdquo;</span>");

  hed
    .append("p")
    .attr("class", "name")
    .text(`${candidate.firstname} ${candidate.lastname}`);

  const dob = moment(candidate.dob);
  const electionday = moment("02/28/2023");
  const age = electionday.diff(dob, "years");

  if (candidate["incumbent?"] === "TRUE") {
    hed.append("span").attr("class", "incumbent").text("Incumbent");
  }

  let age_text = "";
  if (age) age_text = `${age} years old`;
  let occupation_text = "";
  if (candidate.occupation) occupation_text = `${candidate.occupation}, `;
  if (age_text || occupation_text) {
    main_info
      .append("p")
      .attr("class", "age")
      .text(`${occupation_text}${age_text}`);
  }

  if (candidate.civic) {
    main_info.append("p").attr("class", "civic").text(candidate.civic);
  }
  if (!candidate.civic && !candidate.statement) {
    main_info
      .append("p")
      .attr("class", "civic")
      .text("Candidate did not respond.");
  }

  card_hed
    .append("div")
    .attr("class", "socials")
    .selectAll("social")
    .data(
      [
        "website",
        "fb",
        "twitter",
        "ig",
        "tiktok",
        "linkedin",
        "youtube",
      ].filter((d) => candidate[d])
    )
    .enter()
    .append("a")
    .attr("target", "_blank")
    .attr("href", (d) => {
      if (d === "twitter") return `https://twitter.com/${candidate[d]}`;
      return candidate[d];
    })
    .html((d) => social_icons[d]);

  let statement = card.append("p").attr("class", "desc");

  if (candidate["statement"]) {
    statement.text(`"${fixText(candidate["statement"])}"`);
  }
  if (!candidate.statement && candidate.civic) {
    statement.text("Candidate did not submit statement.");
  }

  container.append("hr");
};

export const render_list = (
  container,
  data,
  all = false,
  obj,
  candidate_data
) => {
  container.selectAll(".candidates").remove();
  container.selectAll("button").remove();

  const list = container
    .selectAll("div")
    .data(
      data.map((d) => {
        return {
          val: d,
          toggle: all,
        };
      })
    )
    .join("div")
    .attr("class", (d) => `item-${d.val} item`)
    .html(null);

  const btn = list.append("button");
  const btn_text = btn.append("div").attr("class", "btn-text");
  btn_text.append("p").text((d) => {
    return `${obj.text} ${d.val}`;
  });
  btn_text.append("span").text((d) => {
    const num_of_candidates = candidate_data.filter(
      (o) => +o[`${obj.val}#`] === +d.val
    ).length;
    return `${num_of_candidates} ${
      num_of_candidates === 1 ? "candidate" : "candidates"
    }`;
  });
  const arrow = btn.append("span").attr("class", "ar");
  arrow.html((d) => toggle_arrows(d.toggle));
  btn.on("click", (e, d) => {
    d.toggle = !d.toggle;
    arrow.html((d) => toggle_arrows(d.toggle));
    if (d.toggle) {
      btn.style("position", "sticky").style("top", 0);
      const data = candidate_data.filter((o) => +o[`${obj.val}#`] === +d.val);
      const info = container
        .select(`.item-${d.val}`)
        .append("div")
        .attr("class", "candidates");
      data
        .sort((a, b) => {
          return +a.ballotorder > +b.ballotorder ? 1 : -1;
        })
        .map((candidate) => render_card(info, candidate));
      window.dataLayer.push({
        event: "e_ToggleCard",
        dl_candidateType: obj.val === "ward" ? "alderman" : "police-council",
        dl_regionType: obj.val === "ward" ? "ward" : "police-district",
        dl_regionNumber: d.val,
      });
    } else {
      btn.style("position", "relative");
      container.selectAll(`.item-${d.val} .candidates`).remove();
    }
  });
  if (data.length === 1) {
    list.selectAll("button").style("position", "sticky").style("top", 0);
    const i_data = candidate_data.filter((o) => +o[`${obj.val}#`] === data[0]);
    const info = container
      .select(`.item-${data[0]}`)
      .append("div")
      .attr("class", "candidates");
    i_data
      .sort((a, b) => {
        return +a.ballotorder > +b.ballotorder ? 1 : -1;
      })
      .map((candidate) => render_card(info, candidate));
  }
  if (all) {
    data.map((d) => {
      list.selectAll("button").style("position", "sticky").style("top", 0);
      const info = container
        .select(`.item-${d}`)
        .append("div")
        .attr("class", "candidates");
      const data = candidate_data.filter((o) => +o[`${obj.val}#`] === +d);
      data
        .sort((a, b) => {
          return +a.ballotorder > +b.ballotorder ? 1 : -1;
        })
        .map((candidate) => render_card(info, candidate));
    });
  }
};

export const list_toggles = {
  pd: false,
  ald: false,
};

const ald_btn = alderperson
  .append("button")
  .attr("class", "ald_dropdown")
  .text("See all 50 wards")
  .on("click", () => {
    list_toggles.ald = !list_toggles.ald;
    if (list_toggles.ald) {
      candidates.select(".ald_dropdown").text("See less");
      render_list(
        ald_list,
        ward_nums,
        false,
        { text: "Ward", val: "ward" },
        ward_data
      );
    } else {
      candidates.select(".ald_dropdown").text("See all 50 wards");
      render_list(
        ald_list,
        [1, 2, 3, 4, 5],
        false,
        { text: "Ward", val: "ward" },
        ward_data
      );
    }
  });

const pd_btn = police_department
  .append("button")
  .attr("class", "pd_dropdown")
  .text("See all 22 police districts")
  .on("click", () => {
    list_toggles.pd = !list_toggles.pd;
    if (list_toggles.pd) {
      candidates.select(".pd_dropdown").text("See less");
      render_list(
        pd_list,
        police_dist_nums,
        false,
        { text: "Police District", val: "pd" },
        pd_data
      );
    } else {
      candidates.select(".pd_dropdown").text("See all 22 police districts");
      render_list(
        pd_list,
        [1, 2, 3, 4, 5],
        false,
        { text: "Police District", val: "pd" },
        pd_data
      );
    }
  });

export const render_candidates = () => {
  sel.ward
    ? render_list(
        ald_list,
        [sel.ward],
        false,
        { text: "Ward", val: "ward" },
        ward_data
      )
    : render_list(
        ald_list,
        [1, 2, 3, 4, 5],
        false,
        { text: "Ward", val: "ward" },
        ward_data
      );
  sel.precinct
    ? render_list(
        pd_list,
        [sel.precinct],
        false,
        { text: "Police District", val: "pd" },
        pd_data
      )
    : render_list(
        pd_list,
        [1, 2, 3, 4, 5],
        false,
        { text: "Police District", val: "pd" },
        pd_data
      );
  ald_btn.style("display", sel.ward ? "none" : "block");
  pd_btn.style("display", sel.precinct ? "none" : "block");
};
